import React, { Component } from "react"
import FormText from "../form-elements/form-text"
import * as htmlHelper from "../../helpers/html"
import { isValidPhoneNumber } from "react-phone-number-input"
import * as dateHelper from "../../booking/helpers/date"
import PhoneNumberValidationField from "../phone-number-validation-field/phone-number-validation-field"

const emailValidatingRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

class TravelGuideStep3 extends Component {
  constructor(props) {
    super(props)
    this.checkboxRef = React.createRef()
    this.state = {
      invalidData: false,
      termsCondition: false,
      inputElementIdInFocus: "",
    }
  }
  componentDidMount() {
    if (this.props.profile && Object.keys(this.props.profile).length > 0) {
      this.props.writeToState({ email: this.props.profile.EmailAddress })
      this.props.writeToState({ mobile: this.props.profile.ContactDetails?.MobilePhone })
      this.props.writeToState({ mobilePhoneVerified: this.props.profile.ContactDetails?.MobilePhoneVerified })
      this.setState({ termsCondition: this.props.profile.ContactDetails?.NewsletterSubscription })
    }
  }
  componentDidUpdate(prevPros, prevState) {
    if (prevPros.profile !== this.props.profile) {
      this.props.writeToState({ email: this.props.profile.EmailAddress })
      this.props.writeToState({ mobile: this.props.profile.ContactDetails?.MobilePhone })
      this.setState({ termsCondition: this.props.profile.ContactDetails?.NewsletterSubscription })
    }

    if (prevState.inputElementIdInFocus !== this.state.inputElementIdInFocus) {
      if (this.state.inputElementIdInFocus === "checkbox") this.checkboxRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  handleInputChange(data) {
    this.setState({ invalidData: false }, () => this.props.writeToState(data))
  }

  handleSubmit() {
    const { email, mobile, arrivingFlightId, departingFlightId } = this.props
    const { termsCondition } = this.state
    const validEmail = email && emailValidatingRegex.test(email)
    let data = {
      invalidData: true,
    }
    if (termsCondition && email && email.length > 0 && validEmail) {
      if (arrivingFlightId?.length > 0 || departingFlightId?.length > 0) {
        if (mobile && mobile.length > 3) {
          if (isValidPhoneNumber(mobile)) {
            this.props.submitHandler()
            return
          } else {
            data.inputElementIdInFocus = "phoneNumber"
          }
        } else {
          this.props.submitHandler()
          return
        }
      }
    } else {
      if (!termsCondition) data.inputElementIdInFocus = "checkbox"
      if (!mobile || (mobile?.length > 3 && !isValidPhoneNumber(mobile))) data.inputElementIdInFocus = "mobile"
      if (!email || email?.length === 0 || (email?.length > 0 && !validEmail)) data.inputElementIdInFocus = "email"
    }
    this.setState({ ...data })
  }

  handleTermsConditionClick(checked) {
    this.setState({ termsCondition: checked })
  }

  getTravelFormTranslation(option) {
    const { config } = this.props
    let translation = ""
    const formattedOption = option.toLowerCase().replace(/\s/g, "")
    switch (formattedOption) {
      case "bus":
        translation = config.transportToAirportBusOptionText || "Bus"
        break
      case "drivenbyanother":
        translation = config.transportToAirportDriveOptionText || "Kørt"
        break
      case "privatecar(ormotorcycle,scooter)":
        translation = config.transportToAirportPrivateCarOptionText || "Privat bil (eller motorcykel, knallert)"
        break
      case "flight(transit)":
        translation = config.transportToAirportPlaneOptionText || "Fly (transit)"
        break
      case "metro":
        translation = config.transportToAirportMetroOptionText || "Metro"
        break
      case "taxi":
        translation = config.transportToAirportTaxiOptionText || "Taxi"
        break
      case "train":
        translation = config.transportToAirportTrainOptionText || "Tog"
        break
      case "other":
        translation = config.transportToAirportOtherOptionText || "Anden"
        break
      case "null":
      case null:
        translation = config.doNotKnowText || "Ved det ikke endnu"
        break
    }
    return translation
  }
  render() {
    const { invalidData, termsCondition, inputElementIdInFocus } = this.state
    const { departingFlight, arrivingFlight } = this.props
    const { travelsWithChildren, travelsWithLuggage, travelForm, config, email, mobile } = this.props
    const departingTime = departingFlight && dateHelper.formatDate(departingFlight.ScheduledTime, "HH.mm", "da")
    const departingDate = departingFlight && dateHelper.formatDate(departingFlight.ScheduledTime, "DD.MM.YYYY", "da")
    const arrivingTime = arrivingFlight && dateHelper.formatDate(arrivingFlight.ScheduledTime, "HH.mm", "da")
    const arrivingDate = arrivingFlight && dateHelper.formatDate(arrivingFlight.ScheduledTime, "DD.MM.YYYY", "da")
    const validEmail = email && emailValidatingRegex.test(email)

    return (
      <React.Fragment>
        <div className="w--wider">
          <div className="form form-padding-top">
            {this.props.profile && this.props.email ? (
              ""
            ) : (
              <div className="form__section">
                <h4>{config.emailText || "Email"}</h4>
                <div className="form__section__inner">
                  <FormText
                    id="emailInput"
                    name="email"
                    type="email"
                    modifier={`form__field form__field--text ${email?.length > 0 && "is-filled"} ${
                      (!email && invalidData) || (invalidData && !validEmail) ? "is-invalid" : ""
                    }`}
                    onChange={(e) => this.handleInputChange({ email: e.currentTarget.value })}
                    label={config.emailPlaceholderText || "Indtast e-mail"}
                    labelModifier={"form__label"}
                    inputModifier={"form__item"}
                    formNotice={config.emailErrorText || "Ugyldig email"}
                    isInvalid={(!email && invalidData) || (invalidData && !validEmail)}
                    showFormNotice={(!email && invalidData) || (invalidData && !validEmail)}
                    labelPositionTop={false}
                    isFocus={inputElementIdInFocus === "email"}
                  />
                </div>
              </div>
            )}

            {this.props.profile ? (
              <div className="form__section">
                <h4>{config.mobileText || "Mobilnummer"}</h4>
                <div className="form__section__inner">
                  <PhoneNumberValidationField placeholder={"+45"} profile={this.props.profile} textKeys={config.phoneValidationField} />
                </div>
              </div>
            ) : (
              <div className="form__section">
                <h4>{config.mobileText || "Mobilnummer"}</h4>
                <div className="form__section__inner">
                  <FormText
                    id="phoneNumberInput"
                    name="phoneNumber"
                    type="tel"
                    placeholder={"+45"}
                    modifier={`form__field form__field--text is-filled ${mobile && invalidData && !isValidPhoneNumber(mobile) ? "is-invalid" : ""}`}
                    onChange={(e) => this.handleInputChange({ mobile: e.currentTarget.value })}
                    label={config.mobilePlaceholderText || "Indtast mobilnummer"}
                    labelModifier={"form__label"}
                    inputModifier={"form__item"}
                    formNotice={config.mobileErrorText || "Mobilnummeret ugyldigt, husk det skal indeholde en landekode (+45)"}
                    isInvalid={mobile && invalidData && !isValidPhoneNumber(mobile)}
                    showFormNotice={mobile && invalidData && !isValidPhoneNumber(mobile)}
                    labelPositionTop={false}
                    isFocus={inputElementIdInFocus === "phoneNumber"}
                  />
                </div>
              </div>
            )}

            {this.props.profile && this.state.termsCondition ? (
              ""
            ) : (
              <div className="form__section">
                <div className="form__section__inner">
                  <div ref={this.checkboxRef} className={`form__field form__field--checkbox ${!termsCondition && invalidData ? "is-invalid" : ""}`}>
                    <label className="form__label">
                      <input
                        className="form__item "
                        id="terms_conditions"
                        name="check-name"
                        type="checkbox"
                        defaultChecked={false}
                        onClick={(e) => this.handleTermsConditionClick(e.currentTarget.checked)}
                      />
                      <span className="form__label__text">
                        {(config.termsConditionText && htmlHelper.htmlStringToReactElement(config.termsConditionText)) || (
                          <React.Fragment>
                            <h5>
                              Vi guider dig trygt gennem lufthavnen og på din rejse&nbsp;&nbsp;<strong>&nbsp;</strong>
                            </h5>
                            <p>
                              Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem
                              ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum
                              dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet...
                            </p>
                          </React.Fragment>
                        )}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="flights-block deck--grey_v2 style_v2">
            {departingFlight && (
              <div className="flight-tile">
                <div className="title">
                  {config.firstTabName || "Afrejse"} {departingFlight.Flight}
                </div>
                <span className="small-text strong">{departingFlight.DestinationName}</span>
                <span className="small-text">
                  {departingFlight.CarrierName}, {departingDate} kl. {departingTime}
                </span>
              </div>
            )}
            {arrivingFlight && (
              <div className="flight-tile">
                <div className="title">
                  {config.secondTabName || "Hjemrejse"} {arrivingFlight.Flight}
                </div>
                <span className="small-text strong">{arrivingFlight.DestinationName}</span>
                <span className="small-text">
                  {arrivingFlight.CarrierName}, {arrivingDate} kl. {arrivingTime}
                </span>
              </div>
            )}
            {(travelsWithLuggage !== undefined || travelForm !== undefined || travelsWithChildren !== undefined) && (
              <div className="flight-options small-text">
                {travelsWithLuggage !== undefined && (
                  <div className="flight-option">
                    <span className="left">{config.travelWithLuggageText || "Rejser du med indchecket bagage"}:</span>
                    <span className="right strong">
                      {travelsWithLuggage
                        ? config.yesText || "Ja"
                        : travelsWithLuggage === null
                          ? config.doNotKnowText || "Ved det ikke endnu"
                          : config.noText || "Nej"}{" "}
                    </span>
                  </div>
                )}
                {travelForm !== undefined && (
                  <div className="flight-option">
                    <span className="left">{config.transportToAirportText || "Transport til lufhavnen"}:</span>
                    <span className="right strong">{this.getTravelFormTranslation(travelForm)}</span>
                  </div>
                )}
                {travelsWithChildren !== undefined && (
                  <div className="flight-option">
                    <span className="left">{config.travelWithChildrenText || "Rejser du med børn"}:</span>
                    <span className="right strong">
                      {travelsWithChildren
                        ? config.yesText || "Ja"
                        : travelsWithChildren === null
                          ? config.doNotKnowText || "Ved det ikke endnu"
                          : config.noText || "Nej"}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="button-container">
            <button
              className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                config.goBackButtonBackgroundColor || "button--general is-grey-text"
              }`}
              onClick={() => this.props.stepButtonClickHandler({ activeStep: 2 })}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--planeduo">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/svg/symbols.svg#svg-planeduo">
                    &nbsp;
                  </use>
                </svg>
              </span>
              <span className="text strong">{config.goBackButtonText || "Tilbage"}</span>
            </button>
            <button
              className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                config.subscribeSubmitButtonBackgroundColor || "button--general is-blue-text"
              }`}
              onClick={() => this.handleSubmit()}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--planeduo">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/svg/symbols.svg#svg-planeduo">
                    &nbsp;
                  </use>
                </svg>
              </span>
              <span className="text strong">{config.subscribeSubmitButtonText || "Bekræft meldning"}</span>
            </button>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default TravelGuideStep3
